import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import IconButton from '@material-ui/core/IconButton';
import { ReactComponent as CloseIcon } from '../../../../../Asset/svg/close.svg';
import { IAChatViewMode } from '../types';
import { useIAChatHeaderStyles } from './IAChatHeader.styles';

type IAChatHeaderProps = {
  viewMode: IAChatViewMode;
  showHistoryLink: boolean;
  onShowHistory: () => void;
  onBackToMain: () => void;
  onClose: () => void;
};

const IAChatHeader = ({
  viewMode,
  showHistoryLink,
  onShowHistory,
  onBackToMain,
  onClose,
}: IAChatHeaderProps) => {
  const classes = useIAChatHeaderStyles();

  const closeButton = (
    <button type="button" className={classes.closeButton} onClick={onClose} aria-label="Fermer">
      <CloseIcon className={classes.closeIcon} aria-hidden="true" />
    </button>
  );

  if (viewMode === 'history') {
    return (
      <header className={classes.header}>
        <div className={classes.headerRow}>
          <IconButton
            className={classes.backButton}
            onClick={onBackToMain}
            aria-label="Retour">
            <ArrowBackIcon />
          </IconButton>
          <h2 className={classes.headerTitle}>Historique</h2>
        </div>
        {closeButton}
      </header>
    );
  }

  if (viewMode === 'conversation') {
    return (
      <header className={classes.header}>
        <div className={classes.headerRow}>
          <IconButton
            className={classes.backButton}
            onClick={onBackToMain}
            aria-label="Retour">
            <ArrowBackIcon />
          </IconButton>
          <h2 className={classes.headerTitle}>Votre conseiller Orientaction</h2>
        </div>
        {closeButton}
      </header>
    );
  }

  return (
    <header className={classes.header}>
      <div className={classes.headerContent}>
        <h2 className={classes.headerTitle}>Votre conseiller Orientaction</h2>
        {showHistoryLink && (
          <button type="button" className={classes.historyLink} onClick={onShowHistory}>
            Voir l&apos;historique
          </button>
        )}
      </div>
      {closeButton}
    </header>
  );
};

export default IAChatHeader;
